import React, { useState, useEffect } from 'react';
import fetchWithAuth from '../api/FetchInstance';
import PredioForm from './Predio/PredioComponentes/informacion_general';

import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  FormControl,
  FormLabel,
  Input,
  HStack,
  IconButton,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon, AddIcon } from '@chakra-ui/icons';
import PredioDetail from './Predio/PredioDetalle';

const PredialTesoreria: React.FC = () => {
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();

  const {
    isOpen: isModalOpenx,
    onOpen: onModalOpenx,
    onClose: onModalClosex,
  } = useDisclosure();
  const [transactions, setTransactions] = useState([]);
  const [selectedPredioId, setSelectedPredioId] = useState<string | null>(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [inputValue, setInputValue] = useState(''); // Controla el valor del campo de entrada

  const toast = useToast();
  // Manejar cambios en el campo de entrada
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value); // Solo actualiza el estado del input
  };

  // Manejar clic en el botón de búsqueda
  const handleSearchButtonClick = () => {
    setSearchQuery(inputValue); // Actualiza la búsqueda con el valor del input
    setPage(1); // Reinicia la página
    console.log('Buscando con la consulta:', inputValue);
    // Aquí puedes realizar la búsqueda usando searchQuery
  };
  const fetchTransactions = async () => {
    try {
      const response = await fetchWithAuth(
        `http://52.91.130.91:5000/api/predio?page=${page}&pageSize=${pageSize}&search=${searchQuery}`,
      );
      const data = await response.json();
      //console.log(data)
      setTransactions(data.data);
      setTotalPages(data.pagination.totalPages);
    } catch (error) {
      console.log(error);
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, searchQuery]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  // Manejador para abrir el modal con el id del predio seleccionado
  const handleRowClick = (id: string) => {
    setSelectedPredioId(id);
    setModalOpen(true);
  };

  // Cerrar el modal y limpiar el id seleccionado
  const closeModal = () => {
    setModalOpen(false);
    setSelectedPredioId(null);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Evita el comportamiento por defecto (en formularios)
      handleSearchButtonClick(); // Llama a la función de búsqueda
    }
  };

  const [localidadFilter, setLocalidadFilter] = useState("");
  const [parajeFilter, setParajeFilter] = useState("");

  // Filtrar las transacciones basadas en los filtros
  const filteredTransactions = transactions.filter((transaction) => {
    const localidad = transaction.ClaveCatastral?.cLocalidad?.descripcion || "";
    const paraje = transaction.paraje || "";

    return (
      localidad.toLowerCase().includes(localidadFilter.toLowerCase()) &&
      paraje.toLowerCase().includes(parajeFilter.toLowerCase())
    );
  });

  return (
    <Box p={8} bg="gray.50" borderRadius="md" boxShadow="md" mx="auto" mt={8}>
      <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
        Predial - Tesorería
      </Heading>
      <FormControl id="search" mb={4}>
        <HStack spacing={2}>
          <Input
            onKeyDown={handleKeyDown} // Maneja el evento Enter
            placeholder="Buscar..."
            value={inputValue} // Muestra el valor del campo de entrada
            onChange={handleInputChange} // Actualiza el estado del input sin realizar peticiones
          />
          <Button onClick={handleSearchButtonClick} colorScheme="blue">
            Buscar
          </Button>
        </HStack>
      </FormControl>

      <Box>
      {/* Controles de filtro */}
      <HStack mb={4} spacing={4}>
        <Input
          placeholder="Filtrar por Localidad"
          value={localidadFilter}
          onChange={(e) => setLocalidadFilter(e.target.value)}
        />
        <Input
          placeholder="Filtrar por Paraje"
          value={parajeFilter}
          onChange={(e) => setParajeFilter(e.target.value)}
        />
      </HStack>

      {/* Tabla */}
      <Box overflowX="auto" overflowY="auto" maxHeight="450px">
        <Table variant="simple" size="lg">
          <Thead>
            <Tr>
              <Th>Clave Catastral</Th>
              <Th>Localidad</Th>
              <Th>Nombre Completo</Th>
              <Th>Paraje o Denominacion</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredTransactions.map((transaction, index) => (
              <Tr
                key={index}
                onClick={() => handleRowClick(transaction.id)}
                style={{ cursor: "pointer" }}
              >
                <Td>
                  {transaction.ClaveCatastral?.claveCatastralEstandar || "N/A"}
                </Td>
                <Td>
                  {transaction.ClaveCatastral?.cLocalidad?.descripcion || "N/A"}
                </Td>
                <Td>
                  {`${
                    transaction.ClaveCatastral?.PropietarioPredio?.[0]
                      ?.Propietario?.nombre || "N/A"
                  } ${
                    transaction.ClaveCatastral?.PropietarioPredio?.[0]
                      ?.Propietario?.primerApellido || "N/A"
                  } ${
                    transaction.ClaveCatastral?.PropietarioPredio?.[0]
                      ?.Propietario?.segundoApellido || "N/A"
                  }`}
                </Td>
                <Td>{transaction.paraje || "N/A"}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>

      <HStack spacing={4} mt={4} justifyContent="center">
        <IconButton
          icon={<ChevronLeftIcon />}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
          aria-label="Página anterior"
        />
        <Box>
          Página {page} de {totalPages}
        </Box>
        <IconButton
          icon={<ChevronRightIcon />}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
          aria-label="Página siguiente"
        />
      </HStack>
      <Button
        position="fixed"
        bottom="20px"
        right="20px"
        colorScheme="green"
        borderRadius="2xl"
        size="lg"
        onClick={onModalOpenx}
        boxShadow="lg"
      >
        <AddIcon />
      </Button>
      <Modal isOpen={isModalOpenx} onClose={onModalClosex} size="6xl">
        <ModalOverlay />

        <ModalContent>
        <ModalHeader>Nuevo Predio</ModalHeader>

          <ModalCloseButton />
          <ModalBody>
            <PredioForm></PredioForm>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={closeModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para Detalles del Predio */}
      <Modal isOpen={ModalOpen} onClose={closeModal} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalles del Predio</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedPredioId ? (
              <PredioDetail id={selectedPredioId} /> // Pasa solo el id al componente PredioDetail
            ) : (
              <Text>No se encontraron detalles para este predio.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={closeModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default PredialTesoreria;
